/** Clés d'accès du compte : une seule requête, lue par Mon compte et sa page. */
import { useQuery } from '@tanstack/react-query';
import { api } from '../../core/api.js';

export const PASSKEYS_QUERY = ['auth-passkeys'] as const;

export interface Passkey {
  id: string;
  label: string | null;
  transports: string[];
  createdAt: string;
  lastUsedAt: string | null;
}

/** Autres facteurs du compte : ce qui reste quand une clé est retirée. */
export interface AccountFactors {
  password: boolean;
  totp: boolean;
  mfaMandatory: boolean;
}

export function usePasskeys(enabled = true) {
  return useQuery({
    queryKey: PASSKEYS_QUERY,
    queryFn: () => api<{ items: Passkey[]; limit: number; factors: AccountFactors }>('/auth/passkeys'),
    enabled,
  });
}
